<template>
    <div class="block h-full w-full bg-[#EEEEEE]">
        <div class="setting-not-logged">
            <div
                class="relative flex aspect-[430/140] items-end justify-center bg-[url(/assets/img/setting/banner-setting.png)] bg-contain p-5"
                @click="showLoginModal = true"
            >
                <div class="flex w-full items-center gap-x-2">
                    <img
                        class="h-[40px] w-[40px]"
                        src="/assets/img/setting/avatar.png"
                        alt="avatar"
                    />
                    <span class="text-sm font-semibold capitalize text-white">
                        {{ $t('common.login_setting') }}
                    </span>
                </div>
            </div>
            <BlocksSettingCard :items="menuList" />
        </div>
    </div>
</template>

<script setup>
import { useModalStore, useUserStore } from '~/stores'
import { storeToRefs } from 'pinia'

const useModalStoreInstance = useModalStore()
const { showLoginModal } = storeToRefs(useModalStoreInstance)
const useUserStoreInstance = useUserStore()
const { isLoggedIn } = storeToRefs(useUserStoreInstance)
const router = useRouter()
const DISPLAY_NEWS = useRuntimeConfig().public.DISPLAY_NEWS

onMounted(() => {
    if (isLoggedIn.value) {
        router.push('/account')
    }
})
const menuList = [
    {
        key: 'promotion',
        name: 'user_sidebar.promotion',
        link: '/promotions',
    },
    // {
    //     key: 'vip',
    //     name: 'user_sidebar.vip',
    //     link: '/other/vip',
    // },
    {
        key: 'news',
        name: 'user_sidebar.news',
        link: '/news',
        disabled: DISPLAY_NEWS !== '1',
    },
    {
        key: 'language',
        name: 'common.language',
        link: '',
    },
].filter((item) => !item.disabled)
</script>
